var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeartNewFilledRedBorderWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.7477L3.0515 12.2222C2.26374 11.4116 1.74566 10.3773 1.5681 9.26096C1.39055 8.14461 1.56219 7.00066 2.05956 5.98558V5.98558C2.42322 5.22414 2.96541 4.5618 3.64 4.05488C4.3146 3.54796 5.10164 3.21147 5.9342 3.07402C6.76675 2.93657 7.62019 3.00223 8.42192 3.26541C9.22366 3.52859 9.94997 3.98152 10.5391 4.58566L12 5.99858L13.4619 4.58166C14.0509 3.97751 14.7772 3.52458 15.5788 3.26138C16.3805 2.99819 17.2339 2.93253 18.0664 3.06998C18.8988 3.20744 19.6858 3.54394 20.3603 4.05087C21.0348 4.5578 21.5769 5.22015 21.9404 5.98158V5.98158C22.4378 6.99666 22.6095 8.14061 22.4319 9.25696C22.2543 10.3733 21.7363 11.4076 20.9485 12.2182L12 21.7477Z",
    fill: "#EF3D3D",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeartNewFilledRedBorderWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/heart-new-filled-red-border-white.990d5809012fafa94fa84b82a6f0c043.svg";